import { render, staticRenderFns } from "./PopupSample.vue?vue&type=template&id=6c33cbae"
import script from "./PopupSample.vue?vue&type=script&lang=js"
export * from "./PopupSample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports